"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productAPISearch.name': 'Ricerca Prodotti e Categorie',
    'tools.productAPISearch.description': 'Cerca prodotti e recupera categorie di prodotti utilizzando l\'integrazione SmartShop API',
};
